import { Grid } from '@mui/material';
import { WsTypography, WsTypoVariants, WsTypoColors } from 'wisestep-base';

export const FormLabel = ({ label }: { label: string }) => (
  <Grid item>
    <WsTypography color={WsTypoColors.SENARY} variant={WsTypoVariants.BODY1}>
      {`${label}  :`}
    </WsTypography>
  </Grid>
);
